import { Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryOverview from './components/CategoryOverview';
import LatestArticles from './components/LatestArticles';
import StatsSection, { CTASection } from './components/StatsSection';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteInfo.address,
          addressCountry: 'CN',
        },
        sameAs: Object.values(siteInfo.socialLinks),
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          'target': `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: `${siteInfo.name} - 首页`,
        description: siteInfo.description,
        url: siteInfo.url,
        isPartOf: { '@id': `${siteInfo.url}/#website` },
      },
    ],
  };

  return (
    <>
      <SEO
        title="首页"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={siteInfo.url}
        ogImage="https://readdy.ai/api/search-image?query=Powerful%20masculine%20fitness%20brand%20banner%2C%20warm%20golden%20and%20dark%20color%20scheme%2C%20motivational%20atmosphere%2C%20abstract%20geometric%20elements%2C%20clean%20modern%20design&width=1200&height=630&seq=home-og&orientation=landscape"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Powerful%20masculine%20fitness%20transformation%20background%2C%20athletic%20silhouette%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20abstract%20geometric%20patterns%2C%20motivational%20and%20dynamic%20atmosphere%2C%20modern%20artistic%20style%2C%20strong%20contrast%20with%20dark%20tones&width=1800&height=900&seq=hero-main-bg&orientation=landscape')`,
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/35 to-foreground-950/50"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <p className="text-sm md:text-base text-background-50/80 tracking-widest uppercase mb-4">
              从零到猛男的完整蜕变指南
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 tracking-wide leading-tight">
              猛男诞生记
            </h1>
            <p className="mt-5 md:mt-6 text-base md:text-lg text-background-50/75 max-w-2xl mx-auto leading-relaxed">
              记录一个普通人如何通过科学训练、饮食管理和意志锻炼，一步步蜕变为真正猛男的全过程。
              无论你是健身小白还是瓶颈期老手，这里有最真实的全程干货。
            </p>
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/training-plan"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-400 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                开始蜕变之旅
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 border-2 border-background-50/35 hover:border-background-50/70 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                了解我们
              </Link>
            </div>
          </div>
        </section>

        <FeaturedArticles featured={featuredArticles} />
        <CategoryOverview categories={categories} />
        <StatsSection />
        <LatestArticles />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}